export default "__VITE_ASSET__Bx578HGe__"